import { render, staticRenderFns } from "./TimestampFormatPreview.vue?vue&type=template&id=13a69ef0&"
import script from "./TimestampFormatPreview.vue?vue&type=script&lang=ts&"
export * from "./TimestampFormatPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports